import React, { useState } from 'react'
import { selectActiveBatPrice, selectRenderCardArray, setRenderCardArray } from '../../../redux/3d_game_Slice/panelSlice'
import { useDispatch, useSelector } from 'react-redux'


const ShowHereAllNumber = () => {
  const dispatch = useDispatch()
  let renderCardArry = useSelector(selectRenderCardArray)
  let activeBatPrice = useSelector(selectActiveBatPrice)
  

  let removeCard = (index)=>{
    let copyCardArray = [...renderCardArry]
    copyCardArray.splice(index,1)
    dispatch(setRenderCardArray([...copyCardArray]))
  }

  return (
    <>
      <div style={{ display: "flex", flexWrap:'wrap' }}>
        {renderCardArry.map((card, index) => {
          return (
          <div style={{ width: "7%", background: "white", border: "2px solid #73AD21" }} key={index}>
            <center>
              <h6>{card.number}</h6>
              <h6>{card.betType}</h6>
              <h6>{activeBatPrice}</h6>
              <h6 ><span class="fa fa-close" style={{ color: "red", cursor:'pointer' }} onClick={()=>removeCard(index)}>X</span></h6>
            </center>
          </div>
          )
        })}
        
      </div>
    </>
  )
}

export default ShowHereAllNumber
